import { localDateStr } from "@/pages/entregas/entregasHelpers";

// Iter 97: atalhos de período (Hoje / Ontem / 7 dias / Este mês) — datas em horário local.
export const PERIOD_PRESETS = [
  { key: "hoje", label: "Hoje" }, { key: "ontem", label: "Ontem" },
  { key: "7d", label: "7 dias" }, { key: "mes", label: "Este mês" },
];

export function periodRange(kind, todayStr) {
  const today = new Date();
  if (kind === "hoje") return { start: todayStr, end: todayStr };
  if (kind === "ontem") { const y = localDateStr(new Date(today.getTime() - 86400000)); return { start: y, end: y }; }
  if (kind === "7d") { const d = new Date(today); d.setDate(d.getDate() - 6); return { start: localDateStr(d), end: todayStr }; }
  if (kind === "mes") return { start: `${todayStr.slice(0, 7)}-01`, end: todayStr };
  return null;
}

export const activePeriodKey = (filters, todayStr) =>
  PERIOD_PRESETS.find((p) => { const r = periodRange(p.key, todayStr); return r.start === filters.start && r.end === filters.end; })?.key || null;

export const defaultFilters = (todayStr) => ({
  start: todayStr, end: todayStr, entregador_id: "all", bairro_id: "all", regiao_id: "all", empresa_id: "current", status: "all", tipo_id: "all",
});

export const filtrosAtivos = (filters, todayStr) =>
  filters.start !== todayStr || filters.end !== todayStr ||
  filters.entregador_id !== "all" || filters.bairro_id !== "all" || filters.regiao_id !== "all" ||
  filters.status !== "all" || filters.tipo_id !== "all";

// Query string compartilhada por /dashboard/stats e /reports/{kind} — respeita TODOS os filtros ativos.
export function buildReportParams(filters) {
  const p = new URLSearchParams();
  if (filters.start) p.set("start", filters.start);
  if (filters.end) p.set("end", filters.end);
  for (const k of ["entregador_id", "bairro_id", "regiao_id", "status", "tipo_id"]) {
    if (filters[k] !== "all") p.set(k, filters[k]);
  }
  return p;
}

export const fmtDateBR = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}` : "");
